// extracted by mini-css-extract-plugin
export default {"header":"LinkedInPost_header__1HP0x","photo":"LinkedInPost_photo__LxKAW","postText":"LinkedInPost_postText__H2ZPB","footer":"LinkedInPost_footer__EVTln"};